import type { CategoryId } from '../../types/categories';
import { SportIds } from '../../types/sports';

export type SportId = number;

export type SportState = {
  sportId: SportId;
  sportName: string;
  categories: Array<CategoryId>;
  mainMatchCount: number;
  liveMatchCount: number;
  tvMatchCount: number;
  filters?: Array<number>;
  prematchPromo?: string;
  livePromo?: string;
  warning?: string;
};

export type EntitiesSports = {
  [key: SportId]: SportState;
};

class SportEntity {
  // Used for sports with set layout only in match view but not in match card
  static isSetSport = (id: SportId | null): boolean => {
    const SetsSports = [
      SportIds.BADMINTON,
      SportIds.BEACH_VOLLEY,
      SportIds.BOWLS,
      SportIds.CRICKET,
      SportIds.DARTS,
      SportIds.SQUASH,
      SportIds.SNOOKER,
      SportIds.ESPORT_COUNTER_STRIKE,
      SportIds.TABLE_TENNIS,
      SportIds.TENNIS,
      SportIds.PADEL,
      SportIds.VOLLEYBALL,
      SportIds.ESPORT,
    ];

    return !!SetsSports.find((sportId) => sportId === id);
  };

  // used to get all sports who have set layout
  static isSetLayout = (id: SportId | null): boolean => {
    const SetsSports = [
      SportIds.AUSSIE_RULES,
      SportIds.BADMINTON,
      SportIds.BASEBALL,
      SportIds.BASKETBALL,
      SportIds.BEACH_VOLLEY,
      SportIds.BOWLS,
      SportIds.CRICKET,
      SportIds.DARTS,
      SportIds.FOOTBALL,
      SportIds.ICEHOCKEY,
      SportIds.ESPORT_ICE_HOCKEY,
      SportIds.ESPORT_COUNTER_STRIKE,
      SportIds.ESPORT_BASKETBALL,
      SportIds.SQUASH,
      SportIds.SNOOKER,
      SportIds.TABLE_TENNIS,
      SportIds.TENNIS,
      SportIds.PADEL,
      SportIds.VOLLEYBALL,
    ];

    return !!SetsSports.find((sportId) => sportId === id);
  };
}

export { SportEntity };
